import React, { useMemo } from 'react';
import classNames from 'classnames';

import { Node, ViewFilters } from '@uncinc/react-drupal-core';
import { Container } from '@uncinc/uncinc-react-kitchen-sink';
import { useTranslation } from 'react-i18next';
import { getValidEvents, dateCompare } from '../../../../helpers/events';

import './style.scss';

const ViewAgenda = ({ entities }) => {
  const { t } = useTranslation();

  const entitiesGrouped = useMemo(() => {
    let dates = {};
    entities.forEach((entity) => {
      dates = getValidEvents(entity, dates);
    });
    return dates;
  }, [entities]);
  return (
    <div className="ViewAgenda">
      <Container>
        <ViewFilters
          viewId="agenda"
          display="default"
          // eslint-disable-next-line react/no-unstable-nested-components
          onRender={() => <div />}
        />
        {Object.keys(entitiesGrouped).length > 0 ? (
          Object.keys(entitiesGrouped).sort().map((dateString) => {
            const items = entitiesGrouped[dateString];
            const date = new Date(dateString);
            const month = date.toLocaleString('nl-NL', { month: 'long' });
            const created = `${month} ${date.getFullYear()}`;

            return (
              <div key={date} className="row">
                <div className="col-12 col-md-4 col-xl-3"><h2 className="ViewAgenda__month">{created}</h2></div>
                <div className="col-12 col-md-8 col-xl-6">
                  {items.sort(dateCompare).map((entity) => {
                    const id = entity.getIn(['nid', '0', 'value']);
                    const uuid = entity.getIn(['uuid', 0, 'value']);
                    const langcode = entity.getIn(['langcode', 0, 'value']);
                    const classes = classNames('DossiersContent__row');
                    const delta = entity.get('delta');

                    return (
                      <div key={`${uuid}:${langcode}`} className={classes}>
                        <Node
                          id={id}
                          key={`${uuid}:${langcode}`}
                          entity={entity}
                          viewMode="teaser"
                          delta={delta}
                        />
                      </div>
                    );
                  })}
                </div>
              </div>
            );
          })
        ) : (
          <p>
            {t('implementations.View.no_results')}
          </p>
        )}
      </Container>
    </div>
  );
};

export default ViewAgenda;
